var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivacyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29034 11.7772V11.78H8.79034H15.2574H15.7574V11.7739L16.044 11.7801C16.1792 11.783 16.25 11.8858 16.25 11.9636V17.5636C16.25 17.645 16.1743 17.75 16.0374 17.75H7.96256C7.82567 17.75 7.75 17.645 7.75 17.5636V11.9636C7.75 11.8822 7.82567 11.7772 7.96256 11.7772H7.98197H8.29034ZM9.29034 10.78H14.7574V9.20477C14.7574 7.74628 13.5413 6.54095 12.0238 6.54095C10.5064 6.54095 9.29034 7.74628 9.29034 9.20477V10.78ZM16.0657 10.7803C16.7213 10.7946 17.25 11.319 17.25 11.9636V17.5636C17.25 18.2177 16.706 18.75 16.0374 18.75H7.96256C7.29404 18.75 6.75 18.2177 6.75 17.5636V11.9636C6.75 11.3095 7.29404 10.7772 7.96256 10.7772H7.98197V9.77719V9.20477C7.98197 7.02411 9.79515 5.25 12.0238 5.25C14.2525 5.25 16.0657 7.02411 16.0657 9.20477V10.7803Z",
    fill: "#4a4a4a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1767 14.1875L12.0233 14.2766L11.8701 14.1879C11.7619 14.1252 11.7153 14.0355 11.7153 13.9506C11.7153 13.8 11.8428 13.6597 12.0237 13.6597C12.204 13.6597 12.3321 13.8002 12.3321 13.9506C12.3321 14.0337 12.2856 14.1242 12.1767 14.1875Z",
    stroke: "#4a4a4a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyIcon);
export default __webpack_public_path__ + "static/media/privacy-icon.6fe5d9c81a22091d7a4ce3e5a9e8f61b.svg";
export { ForwardRef as ReactComponent };